<template>
  <div class="c-table-cell">
    <div class="c-table__cell-value">
      <a :href="linkToWorker" target="_blank">
        {{ data.value }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "referral-cell",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    linkToWorker() {
      const routeData = this.$router.resolve({ path: `/personal-employee/${this.data.candidateReferral.id}/summary` });
      return routeData.href;
    },
  },
};
</script>
